const SortByjson = [
    {
        ID: 1, 
        name: "Designation"
    },
    {
        ID: 2, 
        name: "Department"
    },
    {
        ID: 3, 
        name: "Fullname"
    },
    {
        ID: 4, 
        name: "Status"
    }
]

export default SortByjson